import classNames from 'helpers/classNames';
import React from 'react';

export default function GenericCarouselScrollView({
  children,
  fullWidth = false,
}: {
  children?: React.ReactNode;
  fullWidth?: boolean;
}) {
  return (
    <div
      className={classNames(
        'mb-9 flex flex-row overflow-y-auto',
        fullWidth ? '' : 'px-5',
      )}
    >
      {children}
    </div>
  );
}
